
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sales",
      function () {
        return require("private-next-pages/sales/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sales"])
      });
    }
  